import Header from "@/components/Header";
import Footer from "@/components/Footer";

const TerminosServicio = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
            Términos del Servicio
          </h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-8">
            <p className="text-sm text-muted-foreground">
              Última actualización: Enero 2026
            </p>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                1. Información general
              </h2>
              <p>
                Los presentes Términos del Servicio (en adelante, "Términos") regulan el uso 
                de la plataforma HabitusPay, propiedad de HABITUSPAY ESPAÑA SL (CIF: B24795155), 
                accesible a través de habituspay.com y app.habituspay.com.
              </p>
              <p className="mt-4">
                Al registrarse y utilizar nuestros servicios, usted acepta estos Términos en su 
                totalidad. Si no está de acuerdo con alguna de las condiciones, no debe utilizar 
                la plataforma.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                2. Descripción del servicio
              </h2>
              <p>
                HabitusPay es una plataforma de software como servicio (SaaS) de gestión financiera 
                diseñada para empresas del sector inmobiliario. El servicio incluye:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Gestión de tarjetas empresariales por propiedad u obra.</li>
                <li>Control de gastos en tiempo real.</li>
                <li>Configuración de límites y reglas de gasto.</li>
                <li>Subida y gestión de justificantes.</li>
                <li>Conciliación de transacciones.</li>
                <li>Generación de reportes y dashboard ejecutivo.</li>
                <li>Auditoría de actividad.</li>
              </ul>
              <p className="mt-4 p-4 bg-muted rounded-lg">
                <strong>IMPORTANTE:</strong> HabitusPay NO es una entidad financiera, NO ofrece 
                cuentas bancarias y NO custodia fondos. Las tarjetas empresariales son emitidas 
                por proveedores externos regulados (ej. Wallester AS, entidad de dinero electrónico 
                autorizada por el Banco de Estonia).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                3. Registro y cuenta de usuario
              </h2>
              <p>
                Para acceder a la plataforma, es necesario:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Ser mayor de 18 años.</li>
                <li>Actuar en representación de una empresa legalmente constituida.</li>
                <li>Proporcionar información veraz y actualizada.</li>
                <li>Mantener la confidencialidad de sus credenciales de acceso.</li>
              </ul>
              <p className="mt-4">
                El usuario es responsable de todas las actividades realizadas desde su cuenta 
                y debe notificar inmediatamente cualquier uso no autorizado.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                4. Planes y precios
              </h2>
              <h3 className="text-lg font-medium text-foreground mt-4 mb-2">
                4.1 Plan HabitusPay Start (Gratuito)
              </h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Hasta 2 usuarios</li>
                <li>Hasta 2 tarjetas</li>
                <li>Hasta 2 propiedades</li>
                <li>Conciliación manual</li>
                <li>Reportes básicos</li>
              </ul>

              <h3 className="text-lg font-medium text-foreground mt-6 mb-2">
                4.2 Plan HabitusPay Launch
              </h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>€29/mes o €290/año (2 meses gratis)</li>
                <li>Hasta 10 usuarios</li>
                <li>Hasta 10 tarjetas</li>
                <li>Propiedades ilimitadas</li>
                <li>Reglas y alertas</li>
                <li>Conciliación avanzada</li>
                <li>Dashboard ejecutivo</li>
                <li>Reportes avanzados</li>
                <li>Soporte prioritario</li>
              </ul>
              <p className="mt-4">
                Los precios no incluyen IVA (21%) ni las comisiones aplicadas por los proveedores 
                de tarjetas, que serán informadas de forma transparente.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                5. Facturación y pagos
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Los pagos se realizan de forma anticipada (mensual o anual).</li>
                <li>Aceptamos tarjetas de crédito/débito y transferencia bancaria SEPA.</li>
                <li>Las facturas se emitirán electrónicamente conforme a la normativa española.</li>
                <li>El impago puede resultar en la suspensión del servicio tras un período de gracia de 7 días.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                6. Uso aceptable
              </h2>
              <p>
                El usuario se compromete a:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Utilizar el servicio únicamente para fines empresariales legítimos.</li>
                <li>No utilizar la plataforma para actividades fraudulentas o ilegales.</li>
                <li>No intentar acceder a sistemas o datos sin autorización.</li>
                <li>No interferir con el funcionamiento de la plataforma.</li>
                <li>Cumplir con todas las leyes y regulaciones aplicables, incluyendo 
                    normativas antiblanqueo de capitales.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                7. Propiedad intelectual
              </h2>
              <p>
                Todos los derechos de propiedad intelectual sobre la plataforma, incluyendo 
                el software, diseño, logotipos y contenido, pertenecen a HABITUSPAY ESPAÑA SL 
                o sus licenciantes.
              </p>
              <p className="mt-4">
                Se concede al usuario una licencia limitada, no exclusiva, intransferible y 
                revocable para usar la plataforma conforme a estos Términos.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                8. Confidencialidad
              </h2>
              <p>
                Ambas partes se comprometen a mantener la confidencialidad de toda información 
                no pública intercambiada en el marco del servicio. Esta obligación se mantendrá 
                durante la vigencia del contrato y por un período de 2 años tras su finalización.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                9. Disponibilidad del servicio
              </h2>
              <p>
                Nos esforzamos por mantener un nivel de disponibilidad del 99.9% (SLA). No obstante, 
                el servicio puede verse interrumpido por:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Mantenimiento programado (notificado con antelación).</li>
                <li>Circunstancias de fuerza mayor.</li>
                <li>Problemas con proveedores externos.</li>
                <li>Incidentes de seguridad que requieran actuación inmediata.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                10. Limitación de responsabilidad
              </h2>
              <p>
                En la máxima medida permitida por la ley:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>HABITUSPAY ESPAÑA SL no será responsable de daños indirectos, incidentales, 
                    especiales o consecuentes.</li>
                <li>La responsabilidad total estará limitada al importe pagado por el usuario 
                    en los 12 meses anteriores al incidente.</li>
                <li>No somos responsables de las acciones de los proveedores de tarjetas o 
                    cualquier tercero.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                11. Duración y cancelación
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>El contrato se mantiene vigente mientras el usuario tenga una cuenta activa.</li>
                <li>El usuario puede cancelar su cuenta en cualquier momento desde la configuración.</li>
                <li>Las suscripciones de pago no son reembolsables, pero puede continuar usando 
                    el servicio hasta el final del período facturado.</li>
                <li>HABITUSPAY ESPAÑA SL puede suspender o cancelar cuentas por incumplimiento 
                    de estos Términos, previo aviso cuando sea posible.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                12. Modificaciones
              </h2>
              <p>
                Nos reservamos el derecho a modificar estos Términos. Los cambios sustanciales 
                serán notificados con al menos 30 días de antelación. El uso continuado del 
                servicio tras la modificación implica la aceptación de los nuevos Términos.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                13. Ley aplicable y jurisdicción
              </h2>
              <p>
                Estos Términos se rigen por la legislación española. Para la resolución de 
                controversias, las partes se someten a los Juzgados y Tribunales de Madrid, 
                donde tiene su domicilio social HABITUSPAY ESPAÑA SL, salvo cuando el 
                usuario tenga la condición de consumidor, en cuyo caso serán competentes los 
                del domicilio del consumidor.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                14. Contacto
              </h2>
              <p>
                Para cualquier consulta relacionada con estos Términos del Servicio, puede 
                contactar con nosotros:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Correo electrónico: <a href="mailto:soporte@habituspay.com" 
                    className="text-accent hover:underline">soporte@habituspay.com</a></li>
                <li>Soporte: <a href="mailto:soporte@habituspay.com" 
                    className="text-accent hover:underline">soporte@habituspay.com</a></li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TerminosServicio;
